import React from "react";
import styled from "styled-components";

const IconButton = ({ icon ,onClick}) => {
  return <StyledIconButton onClick={onClick}>{icon}</StyledIconButton>;
};

const StyledIconButton = styled.button`
  background: transparent;
  border: none;
  padding: 8px;
`;

export default IconButton;
